import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the view for eliminating note withdrawals.
 */
export default class tableEliminateNoteWithdrawView extends JetView {
    /**
     * Configures the datatable for displaying eliminated note withdrawals.
     * @returns {Object} Configuration object for the datatable.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        return {
            view: 'datatable', // Datatable view
            id: 'tableEliminateNoteWithdraw', // Unique ID for the datatable
            select: true, // Enable row selection
            columns: [
                // Column definitions
                {
                    id: 'NroNoteWithdrawal', // Column ID
                    header: _('Nro Nota Retiro'), // Column header with localization
                    width: 200, // Column width
                    sort: 'int', // Sorting type
                },
                {
                    id: 'DateElimination',
                    header: _('Fecha Eliminación'),
                    fillspace: 0,
                    minWidth: 0,
                    width: 200,
                    sort: 'text',
                    format: dateFormat, // Date formatting for this column
                },
                {
                    id: 'UserDeleted',
                    header: _('Usuario que la Eliminó'),
                    width: 200,
                    sort: 'int',
                },
                {
                    id: 'ValueNote',
                    header: _('Valor Nota'),
                    width: 150,
                    sort: 'int',
                },
                {
                    id: 'Currency',
                    header: _('Moneda'),
                    width: 150,
                    sort: 'int',
                },
                {
                    id: 'DateNote',
                    header: _('Fecha Nota'),
                    fillspace: 0,
                    minWidth: 0,
                    width: 200,
                    sort: 'text',
                    format: dateFormat, // Date formatting for this column
                },
                {
                    id: 'NroUser',
                    header: _('Nro Usuario'),
                    width: 150,
                    sort: 'int',
                },
                {
                    id: 'UserName',
                    header: _('Nombre del Usuario'),
                    width: 200,
                    sort: 'int',
                },
                {
                    id: 'Observations',
                    header: _('Observaciones'),
                    width: 200,
                    sort: 'int',
                },
            ],
            footer: true, // Enable footer
            math: true, // Enable mathematical operations in footer
            loadahead: devConfig.getDefaultDataFetch(), // Data fetch configuration
            pager: 'pagerA', // Pager ID
            url: devConfig.geturlApi() + 'es/GetTableEliminateNoteWithdraw', // API endpoint for data
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The datatable instance.
     */
    init(grid) {
        $$('tableEliminateNoteWithdraw').hide(); // Initially hide the datatable
        this.on(this.app, 'eliminateNoteWithdraw:filter', (filterData) => {
            // Event listener for filtering
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Initialize query string
            for (var i = 0; i < object.length; i++) {
                // Iterate through filter entries
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    // Check for non-object filters
                    if (object[i][0] == 'Datepicker') {
                        // Handle date range filters
                        var date = object[i][1].split(' - ');
                        string1 = string1 + '&dateFrom=' + date[0]; // Add start date to query
                        string1 = string1 + '&dateTo=' + date[1]; // Add end date to query
                    } else {
                        string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add other filters
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        // Handle object filters
                        var object2 = Object.entries(object[i][1]); // Convert object to entries
                        for (var j = 0; j < object2.length; j++) {
                            // Iterate through object entries
                            if (object2[j][1] !== null) {
                                // Check for non-null values
                                if (object2[j][0] === 'start') {
                                    // Handle start date
                                    var d = new Date(object2[j][1]);
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom; // Add start date to query
                                } else {
                                    if (object2[j][0] === 'end') {
                                        // Handle end date
                                        var d = new Date(object2[j][1]);
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo; // Add end date to query
                                    }
                                }
                            }
                        }
                    }
                }
            }
            console.log(string1); // Log the constructed query string
            grid.load(grid.data.url + '?start=0&count=' + grid.data.$pagesize + string1); // Load data with filters
        });
        grid.attachEvent('onItemClick', function (id, e, node) {
            // Event listener for item click
            var item = this.getItem(id); // Get clicked item
            this.$scope.app.callEvent('user:id', [item.Id]); // Trigger user ID event
        });
        this.on(this.app, 'player:select', (Id) => {
            // Event listener for player selection
            grid.load(grid.data.url + '?start=0&count=' + grid.data.$pagesize + '&PlayerId=' + Id); // Load data for selected player
        });
    }
}

// FILE DOCUMENTED
